<template>
  <div>
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
      <el-form-item label="自定义前缀" prop="prefix">
        <el-input class="inputWith" v-model="ruleForm.prefix" :autocomplete="'on'"></el-input>
      </el-form-item>
      <el-form-item label="空码数量" prop="count">
        <el-input-number v-model="ruleForm.count" :min="1" :max="100"></el-input-number>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="submitForm('ruleForm')">确定</el-button>
        <el-button @click="resetForm('ruleForm')">取消</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  data() {
    return {
      ruleForm: {
        count: 1,
        prefix: ''
      },
      rules: {
        count: [{ required: true, message: "请输入空码数量", trigger: "blur" }],
      },
    };
  },
  props: {
    closeFun: {
      type: Function,
      default: () => {},
    },
  },

  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          $utils.api
            .load(
              "admin/system/facility/generateEmptyFacilities",
              this.ruleForm,
              "post"
            )
            .then((res) => {
              $utils.toast.success(res.msg);
              this.$Modal.remove();
              this.$emit("closeFun");
            });
          // alert("submit!");
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.$Modal.remove();
    },
  },
};
</script>

<style></style>